var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","id":"myiframe","width":"100%","height":"800","allowtransparency":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }